// import how_works_1 from '../../../assets/images/how_works_1.png';
// import how_works_2 from '../../../assets/images/basketball_banner_2.png';
// import how_works_3 from '../../../assets/images/how_works_3.png';
// import how_works_4 from '../../../assets/images/basketball_banner_3.png';
// import how_works_football_1 from '../../../assets/images/how_works_football_1.png';
// import how_works_football_2 from '../../../assets/images/how_works_football_2.webp';
// import how_works_football_3 from '../../../assets/images/how_works_football_3.webp';
// import how_works_football_4 from '../../../assets/images/how_works_football_4.webp';
 import how_works_football_5 from '../../../assets/images/fb-homepage.png';
import { COURT_NAME } from '../../../lib/constants/globalConstant';
// import georgia10 from '../../../assets/images/georgia10.webp';
// import georgia11 from '../../../assets/images/goergia11.webp';
// import georgia5 from '../../../assets/images/georgia5.webp';
// import georgia7 from '../../../assets/images/georgia7.webp';

import fb_2 from '../../../assets/images/atlanta13.png';
import fb_3 from '../../../assets/images/atlanta6.png';
import fb_4 from '../../../assets/images/atlanta7.png';


const howItWorksData = [
    {
        id: 1,
        heading: "PICK YOUR ZONE",
        description: `Choose your territory on the field for the 2026 Falcons season — one token, every home game.`,
        image: how_works_football_5,
    },
    {
        id: 2,
        heading: "SELECT YOUR TOKENS",
        description: "Select one or more tokens in each zone - your points are aggregated across all tokens, so the more tokens you buy, the more points you earn.",
        image: fb_2,
    },
    {
        id: 3,
        heading: "EARN POINTS",
        description: "When live action happens in your zone, your tokens activate and you rack up points.",
        image: fb_3,
    },
    {
        id: 4,
        heading: "UNLOCK REWARDS & EXPERIENCES",
        description: "Collectibles, stadium perks, player meet-and-greets, and behind-the-scenes access.",
        image: fb_4,
    },
]

export default howItWorksData